import {
	demoFlights,
	fedSalesDev1Flights,
	Flight,
	insiderFlights,
	latestFlights,
	productionFlights,
	qcInMSXLatestFlights,
	qcInMSXProdFlights,
	qcInMSXStableFlights,
	stableFlights,
	testFlights,
	aircapiFlights,
	usxDemoFlights,
} from './flightList';

export enum DefaultFlightMode {
	Latest = 'latest',
	Stable = 'stable',
	Test = 'test',
	AirCapi = 'aircapi',
	Insider = 'insider',
	Prod = 'production',
	Demo = 'demo',
	msxLatest = 'msxlatest',
	msxStable = 'msxstable',
	msxProd = 'msxprod',
	UsxDemo = 'usxdemo',
	FedSalesDev = 'fedSalesDev',
}

export const defaultFlightList: Record<DefaultFlightMode, Record<Flight, boolean>> = {
	[DefaultFlightMode.Latest]: latestFlights,
	[DefaultFlightMode.Stable]: stableFlights,
	[DefaultFlightMode.Test]: testFlights,
	[DefaultFlightMode.AirCapi]: aircapiFlights,
	[DefaultFlightMode.Insider]: insiderFlights,
	[DefaultFlightMode.Prod]: productionFlights,
	[DefaultFlightMode.Demo]: demoFlights,
	[DefaultFlightMode.msxLatest]: qcInMSXLatestFlights,
	[DefaultFlightMode.msxStable]: qcInMSXStableFlights,
	[DefaultFlightMode.msxProd]: qcInMSXProdFlights,
	[DefaultFlightMode.UsxDemo]: usxDemoFlights,
	[DefaultFlightMode.FedSalesDev]: fedSalesDev1Flights,
};

/**
 * Flights that are seeded by `defaultFlightMode`/hostname and that the backend
 * (`getFlightsV2`) never returns. These are exempt from the
 * `deprecateUIDrivenFlights` kill-switch so host-driven behavior (the embedded
 * MSX layout via `qcInMSX`, the MSX guided tour via `guidedTour`) survives the
 * flight lockdown instead of resolving to `false`.
 *
 * Keep this list minimal: only add a flight that is (a) seeded by
 * `defaultFlightMode` and (b) absent from the `getFlightsV2` response.
 */
export const CLIENT_CONFIG_ONLY_FLIGHTS: Flight[] = [Flight.qcInMSX, Flight.guidedTour];
